import { Button } from 'components/Button';
import { Icon } from 'components/Icon';
import { Link } from 'components/Link';
import { React } from 'libs/react';
import { Text } from 'components/Text';
import { useDealConfiguratorContext } from '../DealConfigureScreen';
import { DealConfiguratorSearch } from './DealConfiguratorSearch';
import { Closeable } from 'components/util/Closeable';
import { Requires } from 'components/user/Requires';
import { useTranslation } from 'components/translation/TranslationProvider';
import './DealStickyMenu.scss';
/**
 * @component DealStickyMenu
 * @since 1.0.0
 */
export function DealStickyMenu(props) {
    const { onClose } = props;
    const { browsePicker, onReplaceItems, deal } = useDealConfiguratorContext();
    const { customLabels, language } = useTranslation();
    const isAgreement = (deal === null || deal === void 0 ? void 0 : deal.type) === 'AGREEMENT';
    return (React.createElement(Closeable, { onClose: onClose },
        React.createElement("div", { className: "deal-sticky-menu" },
            React.createElement("div", { className: "deal-sticky-menu-container" },
                React.createElement("div", { className: "deal-sticky-menu-head" },
                    React.createElement(Link, { className: "deal-sticky-menu-back", route: isAgreement ? 'agreement.manage' : 'deal.manage' },
                        React.createElement(Icon, { className: "deal-sticky-menu-back-picto", value: "arrow-left" }),
                        React.createElement(Text, { className: "deal-sticky-menu-back-label", value: isAgreement
                                ? t('Agreements')
                                : customLabels['Deals'][language] })),
                    React.createElement(Text, { className: "deal-sticky-menu-title", value: isAgreement
                            ? t('Agreement Configuration')
                            : t('Quote Configuration') })),
                React.createElement("div", { className: "deal-sticky-menu-button-container" },
                    React.createElement("div", { className: "deal-sticky-menu-container-search" },
                        React.createElement(DealConfiguratorSearch, { isMenu: true })),
                    React.createElement("div", { className: "deal-sticky-menu-button" },
                        React.createElement(Button, { style: "outline", label: t('Add Product'), onPress: () => browsePicker(true) })),
                    React.createElement(Requires, { permission: "deal.manage" },
                        React.createElement("div", { className: "deal-sticky-menu-button" },
                            React.createElement(Button, { style: "outline", picto: "copy", label: t('Replace content'), onPress: onReplaceItems }))))))));
}
